export default {
  "content": "<path d=\"M22.707 13.707L19.414 17l3.293 3.293-1.414 1.414L18 18.414l-3.293 3.293-1.414-1.414L16.586 17l-3.293-3.293 1.414-1.414L18 15.586l3.293-3.293 1.414 1.414z\" fill=\"#7B61FF\"/><path d=\"M19 2.5a1 1 0 01.832 1.555c-.15.225-.305.618-.435 1.19-.127.556-.216 1.21-.276 1.904C19 8.537 19 9.995 19 11h-2c0-.995 0-2.537.129-4.024.064-.744.163-1.496.318-2.174.023-.101.05-.201.077-.302H5.76c-.675 2.674-.36 4.808.038 7.145.388 2.27.854 4.733.396 7.855H11v2H5a1 1 0 01-.978-1.21c.705-3.29.244-5.74-.195-8.31-.442-2.586-.856-5.286.218-8.774A1 1 0 015 2.5h14z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};